import React from "react";
import Tab from "@components/tabs";
import StoreList from "./StoreList";

const StoreModal = ({ typeId, moduleId }) => {
  const items = [
    {
      label: "Popular",
      component: StoreList,
      props: { type: "Popular", typeId, moduleId },
    },
    {
      label: "Featured",
      component: StoreList,
      props: { type: "Featured", typeId, moduleId },
    },
    {
      label: "Recommended",
      component: StoreList,
      props: { type: "Recommended", typeId, moduleId },
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <h3 style={{ marginBottom: "5px", fontSize: "18px", fontWeight: "600" }}>
        Store List {typeId ? `(Type: ${typeId})` : ""}
      </h3>
      <p style={{ marginBottom: "15px", color: "#666", fontSize: "13px" }}>
        Select stores in the order you want them to appear (1st selected = Rank
        1, 2nd = Rank 2, etc.). Deselect and reselect to change the order.
      </p>
      <Tab items={items} fitContent paramKey="type" />
    </div>
  );
};

export default StoreModal;
